import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const SYSTEM_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.EXTERNAL_IMPORT,
	ROUTE_NAMES.GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG,
	ROUTE_NAMES.GLOBAL_SETTINGS_GLOBAL_PERMISSIONS,
	ROUTE_NAMES.GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD,
	ROUTE_NAMES.GLOBAL_SETTINGS_MIGRATIONS_HOME,
	ROUTE_NAMES.GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL,
	ROUTE_NAMES.GLOBAL_SETTINGS_SHARED_DASHBOARDS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_MAIL_GLOBAL_MAIL_SETTINGS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL,
	ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS,
	ROUTE_NAMES.SETTINGS_AUTOMATION,
	ROUTE_NAMES.SYSTEM_CONFIGURATION,
	ROUTE_NAMES.SYSTEM_DASHBOARD_EDIT,
]);
